import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { Link, RouteComponentProps, withRouter, Redirect } from 'react-router-dom';
import FlashStore from '../../../../services/FlashStore';
import Form from '../../../FormGenerator/Form';
import { loginFields } from '../../../../formFields';
import { Button, Title, Modal } from '../../../../modules/modules';
import AuthService from '../../../../services/AuthService';
import CountryService from '../../../../services/CountryService';

interface ILoginBoxLoginResult {
  user: GQL.IUser;
  country?: GQL.ICountry;
}

interface ILoginBoxProps extends RouteComponentProps<{ language: string }> {
  type?: 'dropdown' | undefined;
  onClose?: () => void;
  onLogin?: (loginResult: ILoginBoxLoginResult) => void;
  login?: MutationFunc;
}

interface ILoginBoxState {
  formFields: any[];
  formValues: any;
  modals: any;
  redirectTo: string;
}

class LoginBox extends React.Component<ILoginBoxProps> {
  
  public state: ILoginBoxState;

  constructor(props: ILoginBoxProps) {
    super(props);

    this.state = {
      formFields: loginFields,
      formValues: {},
      modals: {
        message: false
      },
      redirectTo: '',
    };

    this.onClose = this.onClose.bind(this);
  }

  public handleChange = (value: any, field: string) => {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public setFormState = (fields: any) => {
    this.setState({ fields });
  }

  public async handleSend(form: any) {
    const validation = await form.validate((fields: any) => {
      this.setFormState(fields);
    });

    if (validation) {
      this.login();
    }
  }

  public toggleModal(modal: string, open?: boolean) {
    if (open === undefined) {
      open = !this.state.modals[modal];
    }

    this.setState({ modals: { ...this.state.modals, [modal]: open } });
  }

  public render(): JSX.Element {
    const { type } = this.props;
    const { countryCode } = CountryService.GetInstance();

    if (this.state.redirectTo) {
      return (
        <Redirect to={this.state.redirectTo} />
      );
    }

    switch (type) {
      // case 'popup':
      //   return (
      //     <div>
      //       <Modal
      //         type="message"
      //         open={this.state.modals.message}
      //         onClose={() => this.toggleModal('message', false)}
      //       >
      //         <div style={{ color: 'black' }} className="modal__title">
      //           Successfully logged in!
      //         </div>
      //       </Modal>

      //       <div className={'loginBox' + (type ? ' loginBox--' + type : '')}>
      //         <div>
      //           <div className="loginBox__head">
      //             <Title type="form">Log in</Title>
      //             <button className="modal__close" onClick={this.props.onClose} />
      //           </div>
      //           <div className="loginBox__content">
      //             <div className="form form--login">
      //               <Form
      //                 fields={this.state.formFields}
      //                 values={this.state.formValues}
      //                 handleChange={this.handleChange}
      //               >
      //                 {(form: any) => {
      //                   return (
      //                     <div>
      //                       <Link to={`/${countryCode}/forgottenPw`} className="link">
      //                         Forgot your password?
      //                       </Link>
      //                       <Button
      //                         onClick={() => {
      //                           this.handleSend(form);
      //                         }}
      //                       >
      //                         Log in
      //                       </Button>
      //                       <div className="loginBox__link">
      //                         <Link to={`/${countryCode}/register`} className="link">
      //                           Don't have an account yet? Sign in.
      //                         </Link>
      //                       </div>
      //                     </div>
      //                   );
      //                 }}
      //               </Form>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   );

      case 'dropdown':
        return (
          <div>
            <div className={'loginBox' + (type ? ' loginBox--' + type : '')}>
              <div>
                <div className="form form--login">
                  <Title type={'login'}>Sign in</Title>
                  <Form
                    fields={this.state.formFields}
                    values={this.state.formValues}
                    handleChange={this.handleChange}
                  >
                    {(form: any) => {
                      return (
                        <React.Fragment>
                          <div className="row">
                            <div className="col-12">
                              <Button onClick={() => this.handleSend(form)}>
                                Log in
                              </Button>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-6 text-left" onClick={this.onClose}>
                              <Link to={`/${countryCode}/forgottenPw`}>Lost password</Link>
                            </div>
                            <div className="col-6 text-right" onClick={this.onClose}>
                              <Link to={`/${countryCode}/register`}>New account</Link>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </Form>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div>
            <Modal
              type="message"
              open={this.state.modals.message}
              onClose={() => this.toggleModal('message', false)}
            >
              <div style={{ color: 'black' }} className="modal__title">
                Successfully logged in!
              </div>
            </Modal>

            <div className={'loginBox' + (type ? ' loginBox--' + type : '')}>
              <div>
                <div className="form form--login">
                  <Form
                    fields={this.state.formFields}
                    values={this.state.formValues}
                    handleChange={this.handleChange}
                  >
                    {(form: any) => {
                      return (
                        <div className="row">
                          <div className="col-6 d-flex align-items-center">
                           <Link to={`/${countryCode}/forgottenPw`} className="link">
                              Lost password?
                            </Link>
                          </div>
                          <div className="col-6">
                            <Button
                              onClick={() => {
                                this.handleSend(form);
                              }}
                            >
                              Log in
                            </Button>
                          </div>
                        </div>
                      );
                    }}
                  </Form>
                </div>
              </div>
            </div>
          </div>
        );
    }
  }

  private async login() {
    const { countryCode } = CountryService.GetInstance();

    if (this.props.login == undefined) {
      return;
    }

    const values = this.state.formValues;

    const variables = {
      email: values.Email,
      password: values.Password
    };

    let login: any;
    try {
      login = await this.props.login({ variables });

      this.toggleModal('message', true);
      AuthService.GetInstance().setLogin(login.data.login);
      FlashStore.GetInstance().showMessage('You are logged in', 'success');

      if (this.props.onClose) {
        this.props.onClose();
      }

      if (this.props.onLogin) {
        this.props.onLogin({
          user: login.data.login.user,
          country: login.data.login.country,
        });
      }

    } catch (e) {
      if (e) {
        FlashStore.GetInstance().showMessage('Wrong email or password. Reset forgotten password?', 'error', 5000, `/${countryCode}/forgottenPw`);
      }
    }
  }

  private onClose() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withRouter(LoginBox);



// WEBPACK FOOTER //
// ./src/components/Query/User/Login/LoginBox.tsx